export default __webpack_public_path__ + "static/media/WOR-interview5.cbb835f9.png";